
import { Component, mixins } from 'nuxt-property-decorator';
import { FileBlockModel, FileUploadDto } from 'fourwaves-shared';
import { RawHtml, OutputFile } from 'fourwaves-shared/components';
import ContentBlockMixin from '../ContentBlockMixin';

@Component({
  components: {
    RawHtml,
    OutputFile,
  },
})
export default class FileBlock extends mixins(ContentBlockMixin<FileBlockModel>) {
  get files(): FileUploadDto[] {
    return this.newData.items.map(data => ({
      id: data.fileUploadId[this.$i18n.locale],
      fileName: data.originalFileName[this.$i18n.locale],
      originalFileName: data.originalFileName[this.$i18n.locale],
      size: 0,
      url: data.fileUploadId[this.$i18n.locale] ? this.$api.getFileUploadUrl(data.fileUploadId[this.$i18n.locale]) : '',
      type: data.type[this.$i18n.locale],
    }));
  }
}
